export const SET_TRANSPORT = 'SET_TRANSPORT';
export const SET_START_DATE = 'SET_START_DATE';
export const SET_END_DATE = 'SET_END_DATE';
export const TOGGLE_ALL_INCLUSIVE = 'TOGGLE_ALL_INCLUSIVE';
export const SET_TRIP_DIRECTION = 'SET_TRIP_DIRECTION';
export const TOGGLE_LAST_MINUTE = 'TOGGLE_LAST_MINUTE';
export const SET_LAST_MINUTE = 'SET_LAST_MINUTE';
export const SET_DESTINATIONS = 'SET_DESTINATIONS';
export const TOGGLE_SELECTION = 'TOGGLE_SELECTION';
export const RESET_SELECTION_FIELD = 'RESET_SELECTION_FIELD ';
export const SET_DEPARTURES = 'SET_DEPARTURES';
export const REMOVE_DEPARTURE = 'REMOVE_DEPARTURE';
export const SET_ADULTS = 'SET_ADULTS';
export const SET_CHILDREN_AGE = 'SET_CHILDREN_AGE';
export const RESET_PARTICIPANTS = 'RESET_PARTICIPANTS'
export const SET_FORM_FIELD = 'SET_FORM_FIELD'
export const SET_HOTEL = 'SET_HOTEL';

export const setTransport = (transport) => ({
    type: SET_TRANSPORT,
    payload: transport
})
export const setStartDate = (startDate) => ({
    type: SET_START_DATE,
    payload: startDate
})
export const setEndDate = (endDate) => ({
    type: SET_END_DATE,
    payload: endDate
})
export const setLastMinute = (value) => ({
    type: SET_LAST_MINUTE,
    payload: value
})
export const toggleLastMinute = () => ({
    type: TOGGLE_LAST_MINUTE
})
export const toggleAllInclusive = () => ({
    type: TOGGLE_ALL_INCLUSIVE
})
export const setTripDirection = (value) => ({
    type: SET_TRIP_DIRECTION,
    payload: value
})
export const setDestinations = (destinations) => ({
    type: SET_DESTINATIONS,
    payload: destinations
})
export const toggleSelection = (field, value) => ({
    type: TOGGLE_SELECTION,
    payload: { field, value },
});

export const resetSelection = (field) => ({
    type: RESET_SELECTION_FIELD,
    payload: { field },
});

export const setDepartures = (departures) => ({
    type: SET_DEPARTURES,
    payload: departures
})
export const removeDeparture = (departure) => ({
    type: REMOVE_DEPARTURE,
    payload: departure
})
export const setAdults = (count) => ({
    type: SET_ADULTS,
    payload: count
})
export const setChildrenAge = (children) => ({
    type: SET_CHILDREN_AGE,
    payload: children
})

export const resetParticipants = () => ({
    type: RESET_PARTICIPANTS
})

export const setFormField = (key, value) => ({
    type: SET_FORM_FIELD,
    payload: { key, value }
})

export const setHotel = (value) => ({
    type: SET_HOTEL,
    payload: value
})
